import { useState } from "react";
import { Button, Card, Col, Row } from "antd";
import VenueForm from "./VenueForm";
import VenueList from "./VenueList";

export const Venues = ({ selectedVenueId, onSelectVenue, api, disabled = false, onHideButtons, eventId = undefined }) => {
  const [showCreate, setShowCreate] = useState(false);
  const [showVenueList, setShowVenueList] = useState(true);
  const [newlyAddedVenue, setNewlyAddedVenue] = useState(null);
  const [resetCounter, setResetCounter] = useState(0);
  const [activeAction, setActiveAction] = useState("search");

  const handleAddVenue = () => {
    setActiveAction("add");
    setShowCreate(true);
    setShowVenueList(false);
  };

  const onShowVenueList = () => {
    setActiveAction("search");
    setShowVenueList(true);
    setShowCreate(false);
  };

  return (
    // <Card
    //   variant="borderless"
    //   className="event-card-borderless"
    //   classNames={{
    //     header: "event-card-borderless-header",
    //     body: "event-card-borderless-body"
    //   }}
    //   title={
    //     <span className="event-card-borderless-header-text">
    //       Event Venue
    //     </span>
    //   }
    // >
    <>    
    <Row 
      gutter={[16, 16]} 
      align="middle" 
      style={{ marginBottom: 12 }}
    >
      <Col xs={24} sm={11}>
        <Button
          block
          type={activeAction === "search" ? "primary" : "default"}
          onClick={() => onShowVenueList(true)}
        >
          Search for an existing Venue
        </Button>
      </Col>

      <Col xs={24} sm={2} style={{ textAlign: 'center' }}>
        <span style={{ color: '#888', fontWeight: 500 }}>
          OR
        </span>
      </Col>

      <Col xs={24} sm={11}>
        <Button
          block
          type={activeAction === "add" ? "primary" : "default"}
          onClick={() => handleAddVenue(true)}
        >
          Add a New Venue
        </Button>
      </Col>
    </Row>

      {showCreate ? (
        <VenueForm
          eventId={eventId}
          onSave={(venue) => {
            setNewlyAddedVenue(venue);

            // THIS is the key fix
            onSelectVenue(venue); 

            setShowCreate(false);
            setShowVenueList(true);
          }}

          onCancel={() => {
            setShowCreate(false);
            setShowVenueList(true);
            onShowVenueList();
            // RESET LIST STATE
            setNewlyAddedVenue(null);
            // onSelectVenue(null);

            // trigger list reset
            setResetCounter(prev => prev + 1);

          }}
        />

      ) : (
        showVenueList && (
          <VenueList
            disabled={disabled}
            selectedVenueId={selectedVenueId}
            newlyAddedVenue={newlyAddedVenue}
            resetCounter={resetCounter}
            onSelect={onSelectVenue}
          />
        )
      )}
      </>

    // </Card>
  );
};
